import { tv } from 'tailwind-variants'

export const pipModeVariants = tv({
  slots: {
    container:
      'flex flex-col cursor-pointer h-full w-full items-center justify-center gap-y-deca text-white bg-opacity-70 m-mili bg-[#6A6A6A] rounded-mili ',
    text: 'text-2xl '
  }
})
